export default __webpack_public_path__ + "static/media/upee_girl_a.96a1a370.webp";